import { BackTop, Button, Typography } from "antd";
import { Footer } from "antd/lib/layout/layout";
import Paragraph from "antd/lib/typography/Paragraph";
import { LinkedinOutlined, GithubOutlined } from "@ant-design/icons";
import React from "react";

const { Title } = Typography;

const Footers = () => {
  return (
    <>
      <Footer style={{ backgroundColor: "#112240", textAlign: "center" }}>
        <div style={{ paddingTop: "5rem", textAlign: "center", color: "#fff" }}>
          <Title level={3} style={{ color: "#FFF" }}>
            Follow Me
          </Title>
          <Title
            level={5}
            style={{ textTransform: "uppercase", color: "#FFF" }}
          >
            "Tough times never last, but tough people do."
          </Title>
        </div>

        <Button.Group>
          <a
            href="https://www.linkedin.com/in/abdurrahmanakaid/"
            target="_blank"
            rel="noreferrer"
          >
            <Button type="primary" ghost style={{ margin: "0 1rem " }}>
              {" "}
              <LinkedinOutlined />
              Linked in{" "}
            </Button>
          </a>
          <a
            href="https://github.com/abdurrahman200"
            target="_blank"
            rel="noreferrer"
          >
            <Button type="primary" ghost>
              {" "}
              <GithubOutlined /> Github{" "}
            </Button>
          </a>
        </Button.Group>
        <Paragraph style={{ color: "#FFF", marginTop: "1rem" }}>
          {" "}
          Portfolio ©2021 Created by Abdur Rahman{" "}
        </Paragraph>
      </Footer>
      <BackTop />
    </>
  );
};

export default Footers;
